import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import Logo from "@/components/brand/Logo";

export default function BillingSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let alive = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        if (!alive) return;
        setStatus(data);
        if (data.payment_status !== "paid" && tries < 20) {
          setTimeout(() => setTries((t) => t + 1), 2000);
        }
      } catch (_) {
        setTimeout(() => setTries((t) => t + 1), 2000);
      }
    };
    poll();
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId, tries]);

  const paid = status?.payment_status === "paid";

  return (
    <div className="dark-marketing grain min-h-screen flex items-center justify-center px-6" data-testid="billing-success-page">
      <div className="absolute top-6 left-6">
        <Link to="/"><Logo variant="light" /></Link>
      </div>
      <div className="w-full max-w-lg glass rounded-sm p-8 text-center">
        <p className="editorial-overline">{paid ? "Payment received" : "Confirming payment…"}</p>
        <h1 className="font-serif text-3xl text-ivory-50 mt-3">
          {paid ? "You're all set." : "Waiting for Stripe to confirm."}
        </h1>
        <p className="text-sm text-ivory-200/70 mt-3">
          {paid
            ? "Your plan is active. Head to the dashboard to see your new limits and start compounding."
            : "This usually takes a couple of seconds. We're polling Stripe for the confirmation now."}
        </p>
        <div className="mt-3 text-xs font-mono text-ivory-200/50 break-all" data-testid="billing-session-id">
          {sessionId}
        </div>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/dashboard" data-testid="billing-to-dashboard" className="px-6 py-3 bg-gold-500 hover:bg-gold-400 text-navy-900 font-semibold rounded-sm text-sm">
            Go to dashboard
          </Link>
          <Link to="/pricing" className="px-6 py-3 border border-ivory-200/20 hover:border-gold-500 text-ivory-50 rounded-sm text-sm">
            Back to pricing
          </Link>
        </div>
      </div>
    </div>
  );
}
